import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavTagline from "../nav-tagline/nav-tagline";
import Footer from "../shared/Footer";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp"; //

const ExperianSSO = () => {
  const { isUserLogedIn, userRole, userToken, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      isUserLogedIn: state.isUserLogedIn,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const navigate = useNavigate();
  const [ExperianURL, SetExperianURL] = useState("");

  useEffect(() => {
    GetSSO();
  }, []);

  const GetSSO = async () => {
    let call = "/experian/SSO";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res != null) {
      var url = res.data;
      SetExperianURL(url);
    } else if (res.status === "SERVERERROR") {
    }
  };

  return (
    <div className="ExperianSSO">
      <NavTagline />
      <section className="layout-container">
        <iframe
          id="iframeId"
          src={ExperianURL}
          frameborder="0"
          title="Experian SSO"
          className="full-frame"
        ></iframe>
      </section>
      <Footer />
    </div>
  );
};

export default ExperianSSO;
